import React, { useMemo } from "react";
import {
  formatCoin,
  getGameWheelEntries,
  getInitials,
  isUserCreator,
  sliceColorForIndex,
} from "../../utils/bondWheelHelpers";

const BondWheelStagePlayers = ({ game, userId }) => {
  const entries = useMemo(() => getGameWheelEntries(game), [game]);
  const needsOpenSlot = entries.length === 1;

  if (!game) return null;

  return (
    <section className="bplay-players-panel" aria-label={`${entries.length} tickets in this wheel`}>
      <header className="bplay-players-panel-head">
        <div className="bplay-players-panel-title">
          <span className="bplay-players-panel-label">Tickets</span>
          <span className="bplay-players-panel-count">{entries.length}</span>
        </div>
        <span className="bplay-players-panel-pot">{formatCoin(game.totalPot)} COIN</span>
      </header>

      <div className="bplay-players-panel-body">
        <div className="bplay-players-grid">
          {entries.map((entry, idx) => {
            const name = entry.user?.name || "Player";
            const entryUserId = entry.user?._id || entry.user;
            const isYou = userId && String(entryUserId) === String(userId);
            const isHost = entry.isCreator || isUserCreator(game, entryUserId);
            const displayName = isYou ? "You" : name;

            return (
              <div
                key={String(entry._id || `${entryUserId}-${idx}`)}
                className={`bplay-players-cell ${isYou ? "you" : ""} ${isHost ? "host" : ""}`}
              >
                <div className="bplay-players-cell-top">
                  <span
                    className="bplay-players-avatar"
                    style={{ backgroundColor: sliceColorForIndex(idx) }}
                  >
                    {getInitials(name)}
                  </span>
                </div>
                <div className="bplay-players-cell-bottom">
                  <span className="bplay-players-name" title={name}>
                    {displayName}
                  </span>
                  {isHost ? <span className="bplay-players-tag">host</span> : null}
                </div>
              </div>
            );
          })}

          {needsOpenSlot ? (
            <div className="bplay-players-cell open">
              <div className="bplay-players-cell-top">
                <span className="bplay-players-avatar bplay-players-avatar-open">+</span>
              </div>
              <div className="bplay-players-cell-bottom">
                <span className="bplay-players-name">Open</span>
                <span className="bplay-players-tag muted">waiting</span>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default BondWheelStagePlayers;
